<script>
export default {
  methods: {
    statusObject(statusEnum) {
      switch (statusEnum) {
        case "ReadyToFillOut":
          return { text: "Not filled out", color: "grey" };
        case "SubmittedForApproval":
          return { text: "Submitted for approval", color: "primary" };
        case "Rejected":
          return { text: "Rejected", color: "danger" };
        case "Approved":
          return { text: "Approved", color: "green" };
        case "Sent":
          return { text: "Sent", color: "green" };
        case "NotSent":
          return { text: "Not sent", color: "danger" };
        case "ErrorSending":
          return { text: "Error sending", color: "danger" };
        default:
          return { text: "Unknown", color: "danger" };
      }
    },
    masterStatusObject(statusEnum) {
      switch (statusEnum) {
        case "Draft":
          return { text: "Draft", color: "grey" };
        case "Active":
          return { text: "Active", color: "primary" };
        case "Completed":
          return { text: "Completed", color: "green" };
        default:
          return { text: "Unknown", color: "danger" };
      }
    },
  },
};
</script>